import { useGetModulesWithCategoriesQuery } from '../../graphql/schema';
import Illustration from '../base/Illustration';
import React, { useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { useNavigate } from 'react-router-dom';
import FancyButton from '../base/FancyButton';

const TaskDefinitionsPreview = () => {
  const navigate = useNavigate();

  const { data } = useGetModulesWithCategoriesQuery();

  const handleClick = useCallback(() => {
    navigate('/modules');
  }, [navigate]);

  return (
    <div
      className="w-full md:max-w-3xl lg:max-w-[40rem] xl:max-w-[48rem] mt-2 h-[230px] overflow-hidden relative group cursor-pointer"
      onClick={handleClick}
    >
      <div className="flex flex-wrap gap-3 justify-center">
        {data?.modulesWithCategories.map((module) => (
          <div
            key={module.id}
            className="shadow relative group rounded-lg bg-white space-y-1 flex-col justify-between flex p-3 border-[#efefef] w-[150px] shrink-0 opacity-30 group-hover:opacity-80"
            onClick={handleClick}
          >
            <div className="flex flex-col space-y-1">
              <p className="text-xs font-semibold line-clamp-2">
                {module.title}
              </p>

              <div className="text-gray-500 text-[8px] line-clamp-3">
                {module.description}
              </div>
            </div>

            <div className="flex flex-row justify-between items-end">
              <Illustration id={module.illustration} className="w-[50px]" />
            </div>
          </div>
        ))}
      </div>

      <div className="absolute bottom-0 left-0 w-full h-[150px] bg-gradient-to-b from-transparent to-[#f8f8f8]" />

      {/*
      <div className="group-hover:flex hidden absolute top-0 bottom-0 left-0 w-full justify-center items-center">
        Vorlagen entdecken
      </div>
      */}
    </div>
  );
};

export default TaskDefinitionsPreview;
